// extracted by mini-css-extract-plugin
export default {"module":"question_module__sKN2Q","name":"question_name__Zmmnm","phone":"question_phone__PmhTX","button":"question_button__QkPUa","policy":"question_policy__QWJSD"};